var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrioritize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.53 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 15") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 2.35,
    width: 0.94,
    height: 12.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.06,
    y: 0.94,
    width: 8.47,
    height: 3.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.06,
    y: 6.59,
    width: 8.47,
    height: 3.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.06,
    y: 12.24,
    width: 8.47,
    height: 3.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.47,
    y: 2.35,
    width: 3.76,
    height: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.94,
    y: 13.65,
    width: 6.59,
    height: 0.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.53 5.65 3.53 0 7.06 2.82 3.53 5.65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrioritize);
export default __webpack_public_path__ + "static/media/icon-prioritize.c326d27b1d947e7df6b3107f48861c8b.svg";
export { ForwardRef as ReactComponent };